import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
  * Image slider
  *
  * @param {HTMLElement} el - [data-image-slider]
  * @returns {void}
  *
  * @example
  * <div class="section-media-carousel" data-image-slider data-effect="fade/slide" data-pagination-separator="/" data-prev-helper-text="Previous slide" data-next-helper-text="Next slide">
  *  <div class="swiper-container js-swiper-container">
  *   <div class="swiper-wrapper">
  *
  *    <div class="swiper-slide">
  *      ...
  *    </div>
  *
  *   </div>
  *  </div>
  *
  *  <button class="swiper-button-prev js-swiper-prev-0" aria-label="Previous slide"></button>
  *  <button class="swiper-button-next js-swiper-next-0" aria-label="Next slide"></button>
  *  <div class="swiper-pagination js-swiper-pagination-0"></div>
  * </div>
  *
 */

export default class ImageSlider {
  dom: {
    root: HTMLElement;
    swiperRoot: HTMLElement;
  };

  swiperSettings: {
    effect: string;
    paginationSeparator: string;
    prevHelperText: string;
    nextHelperText: string;
  }

  swiperInstance!: Swiper;

  constructor(el: HTMLElement) {

    this.dom = {
      root: el,
      swiperRoot: el.querySelector('.js-swiper-container') as HTMLElement,
    };

    this.swiperSettings = {
      effect: this.dom.root.dataset.effect || 'slide',
      paginationSeparator: this.dom.root.dataset.paginationSeparator || '/',
      prevHelperText: this.dom.root.dataset.prevHelperText || 'Previous slide',
      nextHelperText: this.dom.root.dataset.nextHelperText || 'Next slide',
    }

    // If every dom element exists, init
    if(Object.keys(this.dom).every(key => this.dom[key])) {
      console.log('image-slider.init()');
      this.swiperInstance = this.initSwiper();
    }
  }

  initSwiper() {
    const nextEl = this.dom.root.querySelector('.js-swiper-next') as HTMLElement;
    const prevEl = this.dom.root.querySelector('.js-swiper-prev') as HTMLElement;
    const paginationEl = this.dom.root.querySelector('.js-swiper-pagination') as HTMLElement;

    return new Swiper(this.dom.swiperRoot, {
      modules: [Navigation, Pagination],
      speed: 500,
      allowTouchMove: true,
      keyboard: true,
      watchSlidesProgress: true,
      slidesPerView: "auto",
      loop: false,
      slideToClickedSlide: true,
      effect: this.swiperSettings.effect || 'slide',
      simulateTouch: true,
      preventClicksPropagation: false,
      preventClicks: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        type: 'custom',
        renderCustom: (_: Swiper, current: number, total: number) => {
          return current + this.swiperSettings.paginationSeparator + total;
        }
      },
      a11y: {
        prevSlideMessage: this.swiperSettings.prevHelperText,
        nextSlideMessage: this.swiperSettings.nextHelperText,
      },
      breakpoints: {
        // when window width is >= 1056px disable touch swipe
        1056: {
          allowTouchMove: false,
        },
      },
    });
  }
}
